/* eslint-disable react-hooks/exhaustive-deps */
import { Form } from 'antd';
import { useEffect } from 'react';
import type { FormInstance } from 'antd/es/form/Form';
import { AdviceDetail } from '@/types/advice';
import { ImageUploadWithEditor } from '@/components/collapse-ck-item';

type Props = {
  index: number;
  detail: AdviceDetail;
  onUpdateDetail: (detail: AdviceDetail) => void;
  onMount: (form: FormInstance, id: number) => void;
  isAdjust: boolean;
  editingData: Record<number, AdviceDetail>;
};

export default function DetailFormItem({
  index,
  detail,
  onUpdateDetail,
  onMount,
  isAdjust = false,
  editingData
}: Props) {
  const [form] = Form.useForm();

  useEffect(() => {
    onMount(form, detail.ID);
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      CONTENT: detail.CONTENT,
      IMAGE: detail.IMAGE
    });
  }, [form, detail, isAdjust]);

  return (
    <Form form={form} layout='vertical'>
      <ImageUploadWithEditor
        title={`${index + 1}. ${detail.TITLE}`}
        form={form}
        isRequired={detail.IS_REQUIRED === 1}
        isUploadImage={detail.IS_UPLOAD === 1}
        item={editingData[detail?.ID] ?? detail}
        onUpdateDetail={onUpdateDetail}
        isAdjust={isAdjust}
      />
    </Form>
  );
}
